import { Box, Paper, Radio } from "@mui/material";
import { AnalysisPeriod } from "../../../../../app/models/general/analysis";
import { translate } from "../../../../translate/translate";
import TableOnlyBodyComponent from "../../../../../app/components/table/table-only-body.component";
import { useMemo } from "react";


interface AnalysisPeriodPageComponentProps {
    handleSelectPeriod: (week: number) => void;
    selectedPeriod: { week: number | null };
}

interface Periods {
  value: AnalysisPeriod;
  label: string;
}

const AnalysisPeriodPageComponent = ({ handleSelectPeriod, selectedPeriod  }: AnalysisPeriodPageComponentProps) => {

  const periodLabels: Periods[] = [
    { value: AnalysisPeriod.FOUR_WEEKS, weeks: 4, months: 1 },
    { value: AnalysisPeriod.EIGHT_WEEKS, weeks: 8, months: 2 },
    { value: AnalysisPeriod.TWELVE_WEEKS, weeks: 12, months: 3 },
    { value: AnalysisPeriod.SIXTEEN_WEEKS, weeks: 16, months: 4 },
    { value: AnalysisPeriod.TWENTY_FOUR_WEEKS, weeks: 24, months: 6 },
    { value: AnalysisPeriod.THIRTY_TWO_WEEKS, weeks: 32, months: 8 },
    { value: AnalysisPeriod.FORTY_EIGHT_WEEKS, weeks: 48, months: 12 },
  ].map(item => ({
    value: item.value,
    label: `${item.weeks} ${translate.t("weeks")} (${item.months} ${translate.t(item.months === 1 ? "month" : "months")})`,
  }));

  const renderRadioButton = (period: Periods) => (
    <Box sx={{ display: "flex", alignItems: "center" }} key={period.value} onClick={() => handleSelectPeriod(period.value)}>
      <Radio
        color="primary"
        id={`radio-${period}`}
        checked={selectedPeriod.week === period.value}
        onChange={() => handleSelectPeriods(period.value)}
      />
      {period.label}
    </Box>
  );

  const mappedDataSource = useMemo(() =>
      periodLabels.map((period) => ({
        ...period,
        radioButton: renderRadioButton(period),
      }))
    , [periodLabels, selectedPeriod]);

  const handleSelectPeriods = (week: number) => {
    handleSelectPeriod(week);
  };

  const renderCellHandler = (column: string, index: number, row: any) => {
    return column === "radioButton" ? row.radioButton : row[column];
  };

  const headerCellCustomStyleHandler = (column: any) => {
    const baseStyle = {
      backgroundColor: "#FFFF !important",
      color: "var(--primary-main) !important",
      borderBottom: "1px solid var(--primary-main)",
      borderTop: "1px solid var(--primary-main)",
    };

    return column === "customer"
      ? { ...baseStyle, paddingLeft: "54px" }
      : baseStyle;
  };

  return (
      <section>
        <Paper variant="outlined" sx={{ marginTop: "16px" }}>
            <TableOnlyBodyComponent
              id="table-analysis-period"
              state={mappedDataSource}
              displayedColumns={["radioButton"]}
              renderCellHandler={{ radioButton: renderCellHandler }}
              headerCellCustomStyleHandler={headerCellCustomStyleHandler}
            />
        </Paper>
      </section>
  );
};

export default AnalysisPeriodPageComponent;
